<template>
  <div class="app-shell" :class="{ 'app-shell--auth': isAuthenticated }">
  <div v-if="mostrarBannerApk" class="apk-banner">
    <div class="container d-flex flex-wrap align-items-center gap-2 py-2">
      <i class="bi bi-phone me-1"></i>
      <span class="flex-grow-1">Instala la app Android: icono propio, pantalla completa y botón atrás.</span>
      <a class="btn btn-sm btn-light" :href="rutaApk">Descargar APK</a>
      <button type="button" class="btn-close btn-close-white" aria-label="Cerrar" @click="cerrarBannerApk"></button>
    </div>
  </div>
  <nav class="navbar navbar-expand-lg app-nav">
    <div class="container">
      <router-link class="navbar-brand" :to="vistaInicio || '/'">Vida</router-link>
      <small class="app-version">v1.124.1</small>
      <button class="navbar-toggler" type="button" @click="toggleNavbar" :aria-expanded="navbarOpen.toString()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        :class="['collapse navbar-collapse', { show: navbarOpen }]"
        id="navbarNav"
        ref="navbarCollapse"
      >
        <ul class="navbar-nav" v-if="isAuthenticated">
          <li class="nav-item">
            <router-link class="nav-link" to="/mi-dia">
              <i class="bi bi-sun me-1"></i>Mi día
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/" active-class="" exact-active-class="is-active">
              <i class="bi bi-receipt me-1"></i>Gastos
              <span v-if="gastosPendientesCount > 0" class="app-badge app-badge--urgente ms-1">{{ gastosPendientesCount }}</span>
            </router-link>
          </li>
          <li class="nav-item dropdown" v-if="isAdmin" ref="saludNavItem">
            <div class="d-flex align-items-stretch">
              <router-link
                class="nav-link d-flex align-items-center"
                :class="{ 'is-active': saludActivo }"
                to="/salud"
                @click="saludMenuOpen = false"
              >
                <i class="bi bi-heart-pulse me-1"></i>Salud
              </router-link>
              <button
                class="btn nav-link dropdown-toggle dropdown-toggle-split border-0 px-2"
                type="button"
                ref="saludDropdownBtn"
                @click.stop="toggleSaludMenu"
                :aria-expanded="saludMenuOpen.toString()"
                aria-label="Más opciones de Salud"
              ></button>
            </div>
            <ul class="dropdown-menu" :class="{ show: saludMenuOpen }">
              <li>
                <router-link class="dropdown-item" to="/salud" @click="saludMenuOpen = false">
                  <i class="bi bi-grid me-2"></i>Resumen
                </router-link>
              </li>
              <li><hr class="dropdown-divider" /></li>
              <li>
                <router-link class="dropdown-item" to="/nutricion" @click="saludMenuOpen = false">
                  <i class="bi bi-egg-fried me-2"></i>Nutrición
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/recetas" @click="saludMenuOpen = false">
                  <i class="bi bi-journal-richtext me-2"></i>Recetas
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/salud-oura" @click="saludMenuOpen = false">
                  <i class="bi bi-activity me-2"></i>Oura
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/salud-fitdays" @click="saludMenuOpen = false">
                  <i class="bi bi-speedometer2 me-2"></i>FitDays
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/salud-coros" @click="saludMenuOpen = false">
                  <i class="bi bi-smartwatch me-2"></i>Coros
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/salud-trainingpeaks" @click="saludMenuOpen = false">
                  <i class="bi bi-calendar2-week me-2"></i>TrainingPeaks
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown" v-if="!isAdmin" ref="saludNavItem">
            <button
              class="btn nav-link dropdown-toggle"
              :class="{ 'is-active': saludActivo }"
              type="button"
              ref="saludDropdownBtn"
              @click="toggleSaludMenu"
              :aria-expanded="saludMenuOpen.toString()"
            >
              <i class="bi bi-heart-pulse me-1"></i>Salud
            </button>
            <ul class="dropdown-menu" :class="{ show: saludMenuOpen }">
              <li>
                <router-link class="dropdown-item" to="/nutricion" @click="saludMenuOpen = false">
                  <i class="bi bi-egg-fried me-2"></i>Nutrición
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/recetas" @click="saludMenuOpen = false">
                  <i class="bi bi-journal-richtext me-2"></i>Recetas
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item" v-if="hasIngresos">
            <router-link class="nav-link" to="/ingresos">
              <i class="bi bi-wallet2 me-1"></i>Ingresos
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/resumen">
              <i class="bi bi-bar-chart me-1"></i>Resumen
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/suscripciones">
              <i class="bi bi-calendar-check me-1"></i>Suscripciones
              <span v-if="suscripcionesProximasCount > 0" class="app-badge app-badge--aviso ms-1">{{ suscripcionesProximasCount }}</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/lista-compra">
              <i class="bi bi-cart3 me-1"></i>Compra
              <span v-if="compraPendientes > 0" class="app-badge app-badge--ok ms-1">{{ compraPendientes }}</span>
            </router-link>
          </li>
          <li class="nav-item dropdown" ref="analisisNavItem">
            <button
              class="btn nav-link dropdown-toggle"
              :class="{ 'is-active': analisisActivo }"
              type="button"
              ref="analisisDropdownBtn"
              @click="toggleAnalisisMenu"
              :aria-expanded="analisisMenuOpen.toString()"
            >
              <i class="bi bi-bar-chart-line me-1"></i>Análisis
            </button>
            <ul class="dropdown-menu" :class="{ show: analisisMenuOpen }">
              <li>
                <router-link class="dropdown-item" to="/gastos-por-categoria" @click="analisisMenuOpen = false">
                  <i class="bi bi-pie-chart me-2"></i>Por categoría
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/gastos-por-mes" @click="analisisMenuOpen = false">
                  <i class="bi bi-calendar-month me-2"></i>Por mes
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/gastos-por-ano" @click="analisisMenuOpen = false">
                  <i class="bi bi-calendar-range me-2"></i>Por año
                </router-link>
              </li>
              <li><hr class="dropdown-divider" /></li>
              <li>
                <router-link class="dropdown-item" to="/gastos-planificados" @click="analisisMenuOpen = false">
                  <i class="bi bi-calendar-plus me-2"></i>Gastos planificados
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/calculadora-fire" @click="analisisMenuOpen = false">
                  <i class="bi bi-fire me-2"></i>FIRE
                </router-link>
              </li>
              <template v-if="isAdmin">
                <li><hr class="dropdown-divider" /></li>
                <li>
                  <router-link class="dropdown-item" to="/analisis-oura" @click="analisisMenuOpen = false">
                    <i class="bi bi-circle-half me-2"></i>Oura Lab
                  </router-link>
                </li>
                <li>
                  <router-link class="dropdown-item" to="/informes" @click="analisisMenuOpen = false">
                    <i class="bi bi-pie-chart me-2"></i>Informes
                  </router-link>
                </li>
                <li>
                  <router-link class="dropdown-item" to="/evolucion" @click="analisisMenuOpen = false">
                    <i class="bi bi-graph-up-arrow me-2"></i>Evolución
                  </router-link>
                </li>
                <li>
                  <router-link class="dropdown-item" to="/wallet" @click="analisisMenuOpen = false">
                    <i class="bi bi-wallet2 me-2"></i>Wallet
                  </router-link>
                </li>
                <li>
                  <router-link class="dropdown-item" to="/fi-cripto" @click="analisisMenuOpen = false">
                    <i class="bi bi-coin me-2"></i>FI y Cripto
                  </router-link>
                </li>
                <li>
                  <router-link class="dropdown-item" to="/cripto-mcp" @click="analisisMenuOpen = false">
                    <i class="bi bi-robot me-2"></i>Cripto MCP
                  </router-link>
                </li>
              </template>
            </ul>
          </li>
          <li class="nav-item dropdown" ref="vidaNavItem">
            <button
              class="btn nav-link dropdown-toggle"
              :class="{ 'is-active': vidaActivo }"
              type="button"
              ref="vidaDropdownBtn"
              @click="toggleVidaMenu"
              :aria-expanded="vidaMenuOpen.toString()"
            >
              <i class="bi bi-grid-3x3-gap me-1"></i>Vida
              <span
                v-if="vidaBadgeCount > 0"
                class="badge rounded-pill bg-danger ms-1"
                style="font-size: 0.65rem;"
              >
                {{ vidaBadgeCount }}
              </span>
            </button>
            <ul class="dropdown-menu" :class="{ show: vidaMenuOpen }">
              <li>
                <router-link class="dropdown-item" to="/my-life" @click="vidaMenuOpen = false">
                  <i class="bi bi-grid-3x3-gap me-2"></i>My Life
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/mi-dia" @click="vidaMenuOpen = false">
                  <i class="bi bi-sun me-2"></i>Mi día
                </router-link>
              </li>
              <li v-if="isAdmin">
                <router-link class="dropdown-item" to="/inspiracion" @click="vidaMenuOpen = false">
                  <i class="bi bi-stars me-2"></i>Inspiración
                </router-link>
              </li>
              <li v-if="isAdmin">
                <router-link class="dropdown-item" to="/gmail" @click="vidaMenuOpen = false">
                  <i class="bi bi-envelope-check me-2"></i>Bandeja
                  <span
                    v-if="gmailInboxCount > 0"
                    class="badge rounded-pill bg-danger ms-auto"
                    style="font-size: 0.65rem;"
                  >{{ gmailInboxCount }}</span>
                </router-link>
              </li>
              <li v-if="isAdmin">
                <router-link class="dropdown-item" to="/seguimiento" @click="vidaMenuOpen = false">
                  <i class="bi bi-truck me-2"></i>Seguimiento
                  <span
                    v-if="pedidosReclamarCount > 0"
                    class="badge rounded-pill bg-danger ms-auto"
                    style="font-size: 0.65rem;"
                  >{{ pedidosReclamarCount }}</span>
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/tareas" @click="vidaMenuOpen = false">
                  <i class="bi bi-check2-square me-2"></i>Tareas
                  <span
                    v-if="tareasCount > 0"
                    class="badge rounded-pill bg-danger ms-auto"
                    style="font-size: 0.65rem;"
                  >{{ tareasCount }}</span>
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/peliculas" @click="vidaMenuOpen = false">
                  <i class="bi bi-film me-2"></i>Películas y series
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
        <ul class="navbar-nav ms-auto">
          <li class="nav-item dropdown" v-if="isAuthenticated" ref="userNavItem">
            <button 
              class="btn nav-link dropdown-toggle d-flex align-items-center" 
              type="button" 
              id="userDropdown"
              ref="userDropdownBtn"
              @click="toggleUserMenu"
              aria-expanded="false"
            >
              <i class="bi bi-person-circle me-1"></i>
              {{ user?.nombre || 'Usuario' }}
            </button>
            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown" ref="userDropdownMenu">
              <li v-if="isAdmin">
                <router-link class="dropdown-item" to="/admin">
                  <i class="bi bi-shield-lock me-2"></i>Administración
                </router-link>
              </li>
              <li v-if="isAdmin"><hr class="dropdown-divider"></li>
              <li>
                <router-link class="dropdown-item" to="/perfil">
                  <i class="bi bi-gear-fill me-2"></i>Editar Perfil
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/grupo">
                  <i class="bi bi-people-fill me-2"></i>Grupo
                  <span
                    v-if="invitacionesGrupoCount > 0"
                    class="badge rounded-pill bg-danger ms-auto"
                    style="font-size: 0.65rem;"
                  >{{ invitacionesGrupoCount }}</span>
                </router-link>
              </li>
              <li><hr class="dropdown-divider"></li>
              <li>
                <a class="dropdown-item" href="#" @click.prevent="logout">
                  <i class="bi bi-box-arrow-right me-2"></i>Cerrar Sesión
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <button
    v-if="isAuthenticated && navbarOpen"
    type="button"
    class="app-nav-backdrop"
    aria-label="Cerrar menú"
    @click="cerrarNavbar"
  ></button>

  <AvisoPush v-if="isAuthenticated" />
  <router-view/>
  <nav v-if="isAuthenticated" class="app-tabbar" aria-label="Atajos">
    <router-link class="app-tabbar__link" to="/" active-class="" exact-active-class="is-active">
      <i class="bi bi-receipt"></i>
      Gastos
    </router-link>
    <router-link class="app-tabbar__link" to="/resumen">
      <i class="bi bi-bar-chart"></i>
      Resumen
    </router-link>
    <button type="button" class="app-tabbar__add" aria-label="Nuevo gasto" @click="irNuevoGasto">
      <i class="bi bi-plus-lg"></i>
    </button>
    <router-link v-if="isAdmin" class="app-tabbar__link" to="/mi-dia">
      <i class="bi bi-sun"></i>
      Mi día
    </router-link>
    <router-link v-else class="app-tabbar__link" to="/lista-compra">
      <i class="bi bi-cart3"></i>
      Compra
    </router-link>
    <button
      type="button"
      class="app-tabbar__more"
      :class="{ 'is-open': navbarOpen }"
      @click="toggleNavbar"
    >
      <i class="bi bi-grid"></i>
      Más
    </button>
  </nav>
  </div>
</template>

<script>
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import axios from './config/axios';
import { sincronizarPushSiActivo } from './utils/pushNotifications';
import AvisoPush from './components/AvisoPush.vue';
import { precargarTick } from './utils/miDia';
import { RUTA_APK, debeMostrarBannerApk, ocultarBannerApk } from './utils/plataforma';
import { resetScrollMenu, revelarSubmenuEnContenedor } from './utils/menuMasMovil';
import {
  gmailInboxCount,
  tareasCount,
  pedidosReclamarCount,
  setGmailInboxCount,
  setTareasCount,
  setPedidosReclamarCount,
  resetNavBadges,
  notificarCambioBandeja,
} from './utils/navBadges';
import { abrirGmailLive } from './utils/gmailLive';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';

export default {
  name: 'App',
  components: { AvisoPush },
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const userDropdownBtn = ref(null);
    const userDropdownMenu = ref(null);
    const userDropdownInstance = ref(null);
    const userNavItem = ref(null);
    const navbarOpen = ref(false);
    const navbarCollapse = ref(null);
    const analisisMenuOpen = ref(false);
    const analisisDropdownBtn = ref(null);
    const analisisNavItem = ref(null);
    const saludMenuOpen = ref(false);
    const saludDropdownBtn = ref(null);
    const saludNavItem = ref(null);
    const vidaMenuOpen = ref(false);
    const vidaDropdownBtn = ref(null);
    const vidaNavItem = ref(null);
    const mostrarBannerApk = ref(debeMostrarBannerApk());
    const rutaApk = RUTA_APK;
    const cerrarBannerApk = () => {
      ocultarBannerApk();
      mostrarBannerApk.value = false;
    };

    const bloquearScrollFondo = (bloquear) => {
      document.body.classList.toggle('app-menu-open', bloquear);
    };

    const cerrarNavbar = () => {
      navbarOpen.value = false;
      analisisMenuOpen.value = false;
      saludMenuOpen.value = false;
      vidaMenuOpen.value = false;
    };

    const revelarSubmenu = (itemRef) => {
      nextTick(() => {
        revelarSubmenuEnContenedor(itemRef.value, navbarCollapse.value);
      });
    };

    const toggleNavbar = () => {
      if (navbarOpen.value) {
        cerrarNavbar();
        return;
      }
      navbarOpen.value = true;
      nextTick(() => {
        resetScrollMenu(navbarCollapse.value);
      });
    };

    const rutasAnalisis = [
      '/gastos-por-categoria',
      '/gastos-por-mes',
      '/gastos-por-ano',
      '/gastos-planificados',
      '/calculadora-fire',
      '/analisis-oura',
      '/evolucion',
      '/informes',
      '/fi-cripto',
      '/wallet',
      '/cripto-mcp'
    ];
    const rutasVida = ['/mi-dia', '/my-life', '/inspiracion', '/gmail', '/seguimiento', '/tareas', '/peliculas'];
    const rutasSalud = [
      '/nutricion',
      '/recetas',
      '/salud',
      '/salud-oura',
      '/salud-fitdays',
      '/salud-coros',
      '/salud-trainingpeaks'
    ];
    const analisisActivo = computed(() => rutasAnalisis.includes(route.path));
    const vidaActivo = computed(() => rutasVida.includes(route.path));
    const saludActivo = computed(() => rutasSalud.includes(route.path));

    const irNuevoGasto = () => {
      cerrarNavbar();
      router.push('/nuevo-gasto');
    };

    const toggleAnalisisMenu = () => {
      analisisMenuOpen.value = !analisisMenuOpen.value;
      if (analisisMenuOpen.value) revelarSubmenu(analisisNavItem);
    };

    const toggleSaludMenu = () => {
      saludMenuOpen.value = !saludMenuOpen.value;
      if (saludMenuOpen.value) revelarSubmenu(saludNavItem);
    };

    const toggleVidaMenu = () => {
      vidaMenuOpen.value = !vidaMenuOpen.value;
      if (vidaMenuOpen.value) revelarSubmenu(vidaNavItem);
    };

    watch(navbarOpen, (abierto) => {
      bloquearScrollFondo(abierto);
      if (!abierto) {
        analisisMenuOpen.value = false;
        saludMenuOpen.value = false;
        vidaMenuOpen.value = false;
      }
    });

    onBeforeUnmount(() => {
      bloquearScrollFondo(false);
      cerrarGmailLive();
    });

    // Cerrar menús al cambiar de ruta
    watch(() => route.path, () => {
      cerrarNavbar();
      if (isAuthenticated.value) {
        cargarGrupoNotiCount();
        cargarGmailInboxCount();
        cargarPedidosReclamar();
      }
    });

    const isAuthenticated = computed(() => store.state.auth?.token !== null);
    const user = computed(() => store.state.auth?.user);
    const isAdmin = computed(() => store.getters['auth/isAdmin']);
    const hasIngresos = computed(() => store.getters['auth/hasIngresos']);
    const vistaInicio = computed(() => store.getters['auth/vistaInicio'] || '/');

    let stopGmailLive = () => {};
    function cerrarGmailLive() {
      try { stopGmailLive(); } catch { /* ignore */ }
      stopGmailLive = () => {};
    }
    function arrancarGmailLive() {
      cerrarGmailLive();
      if (!isAuthenticated.value || !isAdmin.value) return;
      const token = store.state.auth?.token;
      if (!token) return;
      stopGmailLive = abrirGmailLive({
        token,
        onInbox: (payload) => {
          notificarCambioBandeja(payload || {});
          cargarPedidosReclamar();
        },
      });
    }

    const compraPendientes = ref(0);
    const vidaBadgeCount = computed(() => tareasCount.value + (isAdmin.value ? gmailInboxCount.value + pedidosReclamarCount.value : 0));
    const gastosPendientesCount = computed(() => store.getters.gastosPendientesCount);
    const invitacionesGrupoCount = computed(() => store.getters.invitacionesGrupoCount);

    async function cargarTareasCount() {
      try {
        const { data } = await axios.get('/api/tareas');
        setTareasCount(data.total);
      } catch {
        setTareasCount(0);
      }
    }

    // Calienta TickTick (caché del servidor y del navegador) para que Mi día abra al instante.
    function precargarMiDia() {
      precargarTick(axios); // barato: sin TickTick conectado responde al instante
    }

    async function cargarCompraPendientes() {
      try {
        const { data } = await axios.get('/api/lista-compra', { params: { solo: 'resumen' } });
        compraPendientes.value = data.pendientes || 0;
      } catch {
        compraPendientes.value = 0;
      }
    }

    async function cargarGrupoNotiCount() {
      try {
        await store.dispatch('fetchNotificacionesGrupo');
      } catch {
        /* badges a 0 si falla */
      }
    }

    async function cargarPedidosReclamar() {
      if (!isAdmin.value) {
        setPedidosReclamarCount(0);
        return;
      }
      try {
        const { data } = await axios.get('/api/gmail/pedidos/resumen');
        setPedidosReclamarCount(data.reclamar || 0);
      } catch {
        setPedidosReclamarCount(0);
      }
    }

    async function cargarGmailInboxCount() {
      if (!isAdmin.value) {
        setGmailInboxCount(0);
        return;
      }
      try {
        const { data } = await axios.get('/api/gmail/status');
        setGmailInboxCount(data.connected ? (data.inboxTotal || 0) : 0);
      } catch {
        setGmailInboxCount(0);
      }
    }

    // Refrescar conteo de tareas cuando se autentica
    watch(isAuthenticated, (val) => {
      if (val) {
        cargarTareasCount();
        cargarCompraPendientes();
        cargarGrupoNotiCount();
        cargarGmailInboxCount();
        cargarPedidosReclamar();
        sincronizarPushSiActivo();
        arrancarGmailLive();
        precargarMiDia();
      } else {
        resetNavBadges();
        compraPendientes.value = 0;
        cerrarGmailLive();
      }
    });

    const suscripcionesProximasCount = computed(() => {
      const suscripciones = store.state.suscripciones?.suscripciones || [];
      const hoy = new Date();
      const limite = new Date();
      limite.setMonth(hoy.getMonth() + 1);
      return suscripciones.filter(s => {
        if (!s.fecha_fin) return false;
        const fechaFin = new Date(s.fecha_fin);
        return fechaFin >= hoy && fechaFin <= limite;
      }).length;
    });

    const toggleUserMenu = () => {
      if (userDropdownInstance.value) {
        userDropdownInstance.value.toggle();
      } else {
        // Fallback si la instancia no está disponible
        if (userDropdownMenu.value) {
          userDropdownMenu.value.classList.toggle('show');
          if (userDropdownMenu.value.classList.contains('show')) {
            userDropdownBtn.value.setAttribute('aria-expanded', 'true');
          } else {
            userDropdownBtn.value.setAttribute('aria-expanded', 'false');
          }
        }
      }
      nextTick(() => {
        const abierto = userDropdownMenu.value?.classList.contains('show')
          || userDropdownBtn.value?.getAttribute('aria-expanded') === 'true';
        if (abierto) revelarSubmenu(userNavItem);
      });
    };

    onMounted(async () => {
      // Cerrar dropdowns al hacer clic fuera
      document.addEventListener('click', (e) => {
        if (analisisNavItem.value && !analisisNavItem.value.contains(e.target)) {
          analisisMenuOpen.value = false;
        }
        if (saludNavItem.value && !saludNavItem.value.contains(e.target)) {
          saludMenuOpen.value = false;
        }
        if (vidaNavItem.value && !vidaNavItem.value.contains(e.target)) {
          vidaMenuOpen.value = false;
        }
      });

      // Inicializar el dropdown de usuario
      if (userDropdownBtn.value) {
        try {
          userDropdownInstance.value = new bootstrap.Dropdown(userDropdownBtn.value);
          console.log('Dropdown de usuario inicializado correctamente');
        } catch (error) {
          console.error('Error al inicializar dropdown de usuario:', error);
        }
      }

      // Si el usuario está autenticado, cargar los datos iniciales
      if (store.getters['auth/isAuthenticated']) {
        try {
          console.log('Cargando datos iniciales en App.vue...');
          await store.dispatch('initializeData');
          console.log('Datos iniciales cargados correctamente');
        } catch (error) {
          console.error('Error al cargar datos iniciales:', error);
        }
        cargarTareasCount();
        cargarCompraPendientes();
        cargarGrupoNotiCount();
        cargarGmailInboxCount();
        cargarPedidosReclamar();
        sincronizarPushSiActivo();
        arrancarGmailLive();
        precargarMiDia();
      }
    });

    const logout = () => {
      store.commit('auth/logout');
      store.commit('clearData');
      store.commit('suscripciones/clearSuscripciones');
      router.push('/login');
    };

    return {
      isAuthenticated,
      user,
      isAdmin,
      logout,
      userDropdownBtn,
      userDropdownMenu,
      userNavItem,
      toggleUserMenu,
      navbarOpen,
      navbarCollapse,
      toggleNavbar,
      cerrarNavbar,
      irNuevoGasto,
      analisisActivo,
      vidaActivo,
      saludActivo,
      analisisMenuOpen,
      analisisDropdownBtn,
      analisisNavItem,
      toggleAnalisisMenu,
      saludMenuOpen,
      saludDropdownBtn,
      saludNavItem,
      toggleSaludMenu,
      vidaMenuOpen,
      vidaDropdownBtn,
      vidaNavItem,
      toggleVidaMenu,
      suscripcionesProximasCount,
      tareasCount,
      vidaBadgeCount,
      compraPendientes,
      gastosPendientesCount,
      invitacionesGrupoCount,
      hasIngresos,
      vistaInicio,
      gmailInboxCount,
      pedidosReclamarCount,
      mostrarBannerApk,
      rutaApk,
      cerrarBannerApk
    };
  }
};
</script>

<style>
@import 'bootstrap/dist/css/bootstrap.min.css';
@import 'bootstrap-icons/font/bootstrap-icons.css';
@import './assets/shell-theme.css';

.nav-link.dropdown-toggle {
  cursor: pointer;
}

.app-nav .dropdown-menu {
  margin-top: 0.35rem;
}

.app-nav .dropdown-item {
  display: flex;
  align-items: center;
  padding: 0.45rem 0.75rem;
}

.app-nav .dropdown-item i {
  margin-right: 0.5rem;
  font-size: 1.05rem;
}

.app-nav .navbar-nav .nav-link i {
  font-size: 1.05rem;
}

html {
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
}
</style> 


